<template>
  <div class="RwvContentToggleEdit">
    <b-form-group
      :id="'input-group-title-' + index"
      :label-for="'input-title-' + index"
      v-b-tooltip.hover
      title="Titel des Buttons zum Aufklappen">

      <b-form-input
        :id="'input-title-' + index"
        v-model="content.title"
        required
        placeholder="Titel">
      </b-form-input>
    </b-form-group>

    <b-form-group
      :id="'input-group-variant-' + index"
      :label-for="'input-variant-' + index"
      v-b-tooltip.hover
      title="Aussehen des Buttons zum Aufklappen">

      <b-form-input
        :id="'input-variant-' + index"
        v-model="content.variant"
        required
        placeholder="Variante">
      </b-form-input>

      <p class="text-muted small">
        Bsp.: <code>primary</code>, <code>secondary</code> <br>
        Mit dem Prefix <code>outline-</code> wird der Button nicht ausgefüllt. <br>
        Weitere Varianten finden sich
        <a href='https://bootstrap-vue.js.org/docs/components/button#contextual-variants' target='_blank'>hier</a>
      </p>
    </b-form-group>

    <RwvContentEdit :index="index" :content="content.content" :isWithToggle="false"/>
  </div>
</template>

<script>
import RwvContentEdit from "@/components/Contents/ContentEdit";

export default {
  name: "RwvContentToggleEdit",
  props: {
    content: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  beforeCreate: function () {
    this.$options.components.RwvContentEdit = require('../ContentEdit.vue').default
  }
};
</script>

<style lang="scss">
  .RwvContentToggleEdit {
    margin-left: 24px;
    margin-right: 24px;
  }
</style>
